import React, { useState } from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';

const metricOptions = [
  { label: 'Retail Sales', id: 'retailSales', metricType: 'RetailSales' },
  { label: '1P Retail Sales', id: 'onePSales', metricType: 'firstPartySales' },
  { label: '3P Retail Sales', id: 'threePSales', metricType: 'ThirdPartySales' }
];

const AtlasSales1P3PSplineChart = () => {
  const [selectedMetric, setSelectedMetric] = useState(metricOptions[0]);
  const { isProductEntity } = useProductEntity();

  if (isProductEntity) {
    return (
      <AtlasV2DorisSplineChart
        queryKey="RetailSalesSplineChart"
        title="Retail Sales"
        methodName="sales/GetSalesMetrics"
        metricTypeDisplay={METRICTYPE.MONEY}
        metricType="RetailSales"
      />
    );
  }

  return (
    <AtlasV2DorisSplineChart
      queryKey="RetailSalesSplineChart"
      title={selectedMetric.label}
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.MONEY}
      metricType={selectedMetric.metricType}
      beaconChartWithLegendOverride={(props) => {
        return {
          ...props,
          singleDropdownProps: {
            onChange: (s) => setSelectedMetric(metricOptions.find((option) => option.id === s.id)),
            defaultLabel: selectedMetric.label,
            selectedId: selectedMetric.id,
            buttonVariant: 'title',
            options: metricOptions,
            shouldShowFullItemText: true
          }
        };
      }}
    />
  );
};
export default AtlasSales1P3PSplineChart;
